// src/components/shared/ActionChecklist.jsx
import React from "react";

function pct(done, total) {
  if (!total) return 0;
  return Math.round((done / total) * 100);
}

export default function ActionChecklist({ actions, actionKeys, checkedActions, onToggle }) {
  const done = actionKeys.filter((k) => !!checkedActions[k]).length;
  const total = actions.length;
  const ratio = pct(done, total);
  const allDone = total > 0 && done === total;

  const accentBorder = "#3b82f6";

  return (
    <div
      className="mt-1 p-3 rounded-xl"
      style={{
        background: "linear-gradient(145deg, #eff6ff, #dbeafe)",
        border: `1px solid ${accentBorder}40`,
      }}
    >
      <div className="flex items-center justify-between gap-2 mb-2 flex-wrap">
        <div className="text-sm font-semibold uppercase tracking-wide text-slate-600">
          Actiepunten
        </div>
        <div
          className="px-2.5 py-1 rounded-full text-xs font-semibold"
          style={{
            background: allDone ? "#27435d" : "#ffffff",
            color: allDone ? "#ffffff" : "#000000",
            boxShadow: "0 2px 6px rgba(15,23,42,0.25)",
          }}
        >
          {done}/{total} acties · {ratio}%
        </div>
      </div>

      <p className="text-xs text-slate-600 mb-2">
        Vink de actiepunten af zodra ze zijn afgerond.
      </p>

      <div className="space-y-2">
        {actions.map((a, idx) => {
          const actionKey = actionKeys[idx];
          const isChecked = !!checkedActions[actionKey];

          return (
            <div
              key={a.id}
              className="checkbox-row-3d rounded-lg cursor-pointer"
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
                padding: "10px 12px",
                borderRadius: "8px",
                cursor: "pointer",
                background: isChecked
                  ? "#27435d"
                  : "linear-gradient(145deg, #ffffff, #f9fafb)",
                border: isChecked
                  ? `1px solid ${accentBorder}`
                  : "1px solid #e5e7eb",
              }}
              onClick={() => onToggle(actionKey, !isChecked)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onToggle(actionKey, !isChecked);
                }
              }}
            >
              <div
                className={"checkbox-box-3d mt-0.5 flex items-center justify-center rounded-md " +
                  (isChecked ? "checked" : "")}
                style={{
                  width: 22,
                  height: 22,
                  flexShrink: 0,
                  display: "flex",
                  borderRadius: "6px",
                  border: isChecked ? "none" : "2px solid #93c5fd",
                  background: isChecked ? "#27435d" : "#ffffff",
                }}
              >
                {isChecked && (
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </div>
              <div
                className="text-[13px] leading-snug"
                style={{
                  flex: 1,
                  minWidth: 0,
                  color: isChecked ? "#ffffff" : "#374151",
                  textDecoration: isChecked ? "line-through" : "none",
                }}
              >
                {a.text}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
